import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const items = ['más tranquilo', 'menos agotado emocionalmente', 'más seguro para poner límites', 'menos manipulable', 'con más claridad mental', 'con más paz en tu vida diaria'];
export function TransformationSection() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-369" data-mp="2rxrf0fugmncv">
      <div className="max-w-4xl mx-auto text-center" data-id="element-370" data-mp="2nxha76iem2zl">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-371" data-mp="2nyaappqrrw9a">
          <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-4 py-1.5 rounded-full mb-6" data-id="element-372" data-mp="248qa32ku5ucc">
            <span className="text-xs font-bold tracking-widest" data-id="element-373" data-mp="2074sj3xcwrvt">
              LA TRANSFORMACIÓN
            </span>
          </div>
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-374" data-mp="f9hpjiu5oegu">
            Imaginá{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-375" data-mp="5d67ec7vwueh">
              sentirte…
            </span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-3 mb-12 text-left" data-id="element-376" data-mp="a9wpf539202j">
          {items.map((it, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} className="bg-white border border-line rounded-2xl p-5 flex items-center gap-3 shadow-sm" data-id="element-377" data-mp="xzh77kno2ra8" data-mpi={i}>
              <span className="flex-shrink-0 w-7 h-7 rounded-full bg-rose/10 flex items-center justify-center" data-id="element-378" data-mp="1k9zgcftshrq5">
                <CheckIcon className="w-4 h-4 text-rose" strokeWidth={3} data-id="element-379" data-mp="1fb62unei60pz" />
              </span>
              <span className="text-ink font-medium" data-id="element-380" data-mp="1ajwdlnwv8zem">{it}</span>
            </motion.div>)}
        </div>

        <motion.blockquote initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-line rounded-3xl p-8 md:p-12 shadow-sm" data-id="element-381" data-mp="15lmjlgmvo4ul">
          <p className="font-serif-italic text-2xl md:text-3xl leading-relaxed text-ink" data-id="element-382" data-mp="mmqrcauky0je">
            "No se trata de cambiar a todo el mundo. Se trata de aprender a{' '}
            <span className="text-rose font-semibold not-italic" data-id="element-383" data-mp="2h08fo02t71fh">
              protegerte mejor
            </span>
            ."
          </p>
        </motion.blockquote>
      </div>
    </section>;
}